import { useAppDispatch } from '../../store';
import { useAppState } from '../../store/appstate';
import { setTableExpanded } from '../../store/userSettings/userSettingsSlice';

const useTableExpanded = () => {
    const dispatch = useAppDispatch();
    const isTableExpanded = useAppState(s => s.userSettings?.tableExpanded) ?? false;

    const toggleTableExpanded = () => {
        dispatch(setTableExpanded(!isTableExpanded));
    };

    return { isTableExpanded, toggleTableExpanded };
};

export default useTableExpanded;
